import React from 'react'

import Modal from '~/components/modal'
import { i18n } from '~/i18n'

import { ContentBlock } from './sheer-id-removal-modal.styles'

export default ({ toggleModal, handleSheerIdDiscountRemoval }) => (
  <Modal
    size="small"
    title={i18n.t('components.sheer_id_removal_modal.title')}
    onClose={toggleModal}
    actions={{
      primary: {
        text: i18n.t('components.sheer_id_removal_modal.confirm_btn'),
        onClick: handleSheerIdDiscountRemoval,
      },
      secondary: {
        text: i18n.t('components.sheer_id_removal_modal.cancel_btn'),
        onClick: toggleModal,
      },
    }}
  >
    <ContentBlock>
      {i18n.t('components.sheer_id_removal_modal.content')}
    </ContentBlock>
  </Modal>
)
